import { render, staticRenderFns } from "./StockMoveDialog.vue?vue&type=template&id=15420058&"
import script from "./StockMoveDialog.vue?vue&type=script&lang=js&"
export * from "./StockMoveDialog.vue?vue&type=script&lang=js&"
import style0 from "./StockMoveDialog.vue?vue&type=style&index=0&id=15420058&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports